import { createFileRoute } from '@tanstack/react-router';

/** One run, by id; the layout route renders the page. */
export const Route = createFileRoute('/_app/admin/agent/_chat/$runId')({});
